import { useContext } from 'react';
import { domToReact, DOMNode, Element } from 'html-react-parser';
import { NotesContext } from '../contexts/NotesContext';

const useRenderGlossary = (domNode: DOMNode) => {
  const { notes } = useContext(NotesContext);

  if (notes.length === 0 || !(domNode instanceof Element) || !domNode.attribs) return null;

  const noteIndex = parseInt(domNode.attribs.index, 10);
  const title = domToReact(domNode.children as DOMNode[]);
  const noteString = notes[noteIndex];

  if (!noteString) return null;

  const isTerm = domNode.attribs.class === 'termoGlossario';

  return { title, noteString, isTerm };
};

export default useRenderGlossary;
